import(/* webpackMode: "eager" */ "D:\\wORK\\enjoyable\\.enjoyabledesign\\enjoyabledesign\\enjoyabledesign\\src\\app\\blog\\page.tsx");
